import { alertWithMessage } from "components/modal/message_modal";
import { alertWithSuccessMessage } from "components/modal/success_modal";
import { MaxButton } from "components/view/button";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { AppReducerStateProps } from "lib/store";
import cliam_commission from "lib/worker/api/cliam_commission";
import getinfo from "lib/worker/api/getinfo";
import get_transaction_commission_by_member_id, {
  GetTransactionCommissionByMebmerIDResponse,
} from "lib/worker/api/get_transaction_commission_by_member_id";
import { GetServerSideProps } from "next";
import { useEffect, useState } from "react";
import { connect } from "react-redux";

interface FriendRewardProps {
  state: AppReducerStateProps;
  infomation: CheckWithPrefixResponse;
  isLogin: boolean;
}
function FriendReward(props: FriendRewardProps) {
  const [transactionCommission, setTransactionCommission] = useState<
    GetTransactionCommissionByMebmerIDResponse[]
  >([]);

  const cliamCommssion = (hashkey: string) => {
    cliam_commission({ hashkey: hashkey })
      .then(() => {
        alertWithSuccessMessage("รับคอมมิสชั่นสำเร็จ");
      })
      .catch((error) => {
        alertWithMessage(error.response.data.message);
      })
      .finally(() => {
        getinfo();
        reloadTransactionCommission();
      });
  };

  useEffect(() => {
    if (props.isLogin) {
      reloadTransactionCommission();
    }
  }, []);

  const reloadTransactionCommission = () => {
    get_transaction_commission_by_member_id().then((json) => {
      setTransactionCommission(json);
    });
  };

  return (
    <>
      <h2>
        <span>รายได้ประจำวันทุก 17.00 น. ของทุกวัน</span>
      </h2>
      {(transactionCommission ?? []).length == 0 && (
        <div className="container card card-ufa-category color-font-card shadow">
          <div className="margin-left-10">
            <div className="row">
              <div className="col-6">
                <div className="margin-top-10">ยังไม่มีรายการ</div>
              </div>
              <div className="col-6">
                <div className="text-right margin-right-10 margin-top-10 margin-bottom-10">
                  -
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {(transactionCommission ?? []).map((value, index) => {
        return (
          <div
            key={index}
            className="container card card-ufa-category border-ufa-grey shadow"
          >
            <div className="heading margin-left-10">
              <div className="row">
                <div className="col-10">
                  <div>
                    <h4>
                      <span>
                        {index + 1} - {value.NameEN}
                      </span>{" "}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="bottom-line-yellow margin-bottom-10"></div>
            </div>
            <div className="card-body">
              <div>
                <div>
                  <span className="color-font-card">
                    ได้รับ {((value.Amount ?? 0) * 0.001).format(2, 0)}{" "}
                  </span>
                  <span>uDiamond</span>
                </div>
                <div
                  style={{
                    float: "right",
                    marginTop: -23,
                    width: 70,
                  }}
                  className={` ${
                    !value.Uncalculated
                      ? "button-glowing bg-invite"
                      : "bg-invite-disable"
                  }`}
                >
                  <MaxButton
                    title={!value.Uncalculated ? "รับ" : "รับแล้ว"}
                    className={`${
                      value.Uncalculated
                        ? "text-muted bg-nondis"
                        : "bg-purple-submit button-glowing"
                    }`}
                    lock={value.Uncalculated}
                    onClick={() => {
                      cliamCommssion(value.HashKey ?? "");
                    }}
                  ></MaxButton>
                </div>

                <div className="col-10 font-timechat">
                  {value.DisplayCreatedAt}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(FriendReward);
